class BundleProducts extends HTMLElement {
  constructor() {
    super();
    
    this.steps = this.querySelectorAll('[data-step-content]');
    this.stepsTab = this.querySelectorAll('[data-step-tab]');

    this.bundles = this.querySelectorAll('[data-step-bundle]');
    this.bundleProducts = this.querySelectorAll('[data-step-bundle-product]');
    this.bundleSelection = this.querySelector('[data-step-bundle-selected-products]');
    
    this.filterToggle = this.querySelector('[data-filter-toggle]');
   
    // Upsell elements
    this.upsellProducts = this.querySelectorAll('[data-step-upsell-product]');
    this.upsellSelection = this.querySelector('[data-step-bundle-upsell-products]');

    // Rewards elements
    this.rewardsBlocks = this.querySelectorAll(".rewards-popup__rewards-block");
    this.totalSpent = parseInt(document.querySelector('.bundle-products__bundle.selected').dataset.price || 0) / 100;
    this.cta = this.querySelector(".rewards-popup__cta button");
    this.rewardHeading = this.querySelector(".rewards-popup__heading");

    // Add arrays to store selected products
    this.selectedProducts = [];
    this.upsellSelectedProducts = [];
    this.currentBundleData = null;
    this.rewardSelectedProducts = [];
    // Cart reserve timer
    this.cartReserveTimerInterval = null;
    this.cartReserveDurationMs = 10 * 60 * 1000; // 10 minutes
    this.cartReserveEndTime = 0;
  }

  connectedCallback() {
    this.init();
    this.cta?.addEventListener("click", (event) =>
      this.handleRewardSelection(event)
    );
  }

  init() {
    // Initialize with first bundle and set current bundle data
    console.log(this.totalSpent);
    if(this.totalSpent > 0){
      this.handleRewardStep();
    }
    if (this.bundles.length > 0) {
      this.currentBundleData = this.getCurrentBundle(this.bundles[0]);
      this.bundles[0].classList.add('selected');
      this.updateSelectedProductsUI();
      this.updateProductCounts();
      this.updateProductDisabledState();
    }

    this.addEventListener('click', (event) => {
      // close modal
      const closeBtn = event.target.closest('[data-step-modal-close]');
      if (closeBtn) {
        this.close();
        return;
      }

      // Remove one item from selection list
      const removeBtn = event.target.closest('[data-remove-index]');
      if (removeBtn) {
        this.handleRemoveSelected(removeBtn);
        return;
      }

      // Checkout click
      const checkoutBtn = event.target.closest('[data-step-bundle-checkout]');
      if (checkoutBtn) {
        this.handleCheckout(checkoutBtn);
        return;
      }

      // Remove all instances of a product from the grid tile remove button
      const removeAllBtn = event.target.closest('[data-step-bundle-product-remove]');
      if (removeAllBtn) {
        this.handleRemoveAllByProduct(removeAllBtn);
        return;
      }

      // Skip button: clear upsell selection but allow navigation to proceed
      const skipBtn = event.target.closest('[data-step-skip]');
      if (skipBtn) {
        this.handleUpsellSkip();
        // Do not return; let navigation handler below run
      }

      // Filter tag click
      const filterTag = event.target.closest('[data-step-filter-tag]');
      if (filterTag) {
        this.handleFilterTag(filterTag);
        return;
      }

      if (event.target.closest('[data-step-navigation-button]')) {
        const target = event.target.closest('[data-step-navigation-button]');
        this.handleNavigationButton(target);
      }

      if (event.target.closest('[data-step-bundle]')) {
        const target = event.target.closest('[data-step-bundle]');
        this.handleBundleSets(target);
      }

      if (event.target.closest('[data-step-bundle-product]')) {
        const target = event.target.closest('[data-step-bundle-product]');
        this.handleBundleProducts(target);
      }

      // Remove a selected upsell via pill/button
      const upsellRemoveBtn = event.target.closest('[data-upsell-remove-id]');
      if (upsellRemoveBtn) {
        this.handleUpsellRemove(upsellRemoveBtn);
        return;
      }
    });

    // Listen for upsell checkbox toggles
    this.addEventListener('change', (event) => {
      const upsellCheckbox = event.target.matches('input[type="checkbox"][name^="bundle-upsell-"]')
        ? event.target
        : null;
      if (upsellCheckbox) {
        this.handleUpsellToggle(upsellCheckbox);
      }
    });

    if (window.matchMedia('(min-width: 990px)').matches) {
      this.filterToggle.setAttribute('open', true);
    }
  }

  open() {
    document.documentElement.classList.add('overflow-hidden');
    this.classList.add('open');
  }

  close() {
    document.documentElement.classList.remove('overflow-hidden');
    this.classList.remove('open');
  }
 async handleRewardSelection(event) {
  event.preventDefault();
  const activeBlocks = Array.from(
    this.querySelectorAll(".rewards-popup__rewards-block.active")
  );
  const selectedProducts = this.querySelectorAll(
    ".rewards-popup__product-link input:checked"
  );
  // Clear previous selections before adding new ones
  this.rewardSelectedProducts = [];
  Array.from(selectedProducts).forEach((input) => {
    const id = input.value;
    const image = input.dataset.imageUrl;
    const title = input.dataset.productTitle;
    this.rewardSelectedProducts.push({ id, quantity: 1, image, title });
  });
  console.log(this.rewardSelectedProducts);
  if (selectedProducts.length == activeBlocks.length) {
    const wrapper = event.target.closest('.rewards-popup__cta');
    const stepNav = wrapper.previousElementSibling;
    const stepBtn = stepNav?.querySelector('[data-step-navigation-button]:nth-of-type(2)');
    if (stepBtn) {
      this.updateRewardProductsUI();
      stepBtn.click();
    }
  } else {
    alert("Please select a product for each tier.");
  }
}
  async handleCheckout(buttonEl) {
    try {
      // Optional: Require full selection
      if (!this.isSelectionComplete()) {
        // No-op if not complete
        return;
      }

      // Disable button to prevent double submit
      buttonEl.disabled = true;
      buttonEl.classList.add('is-loading');

      // Build items list: include the bundle variant (qty 1)
      const items = [];
      const qtyID = Math.random().toString(36).substring(2, 7);

      if (this.currentBundleData?.id) {
        items.push({ 
          id: Number(this.currentBundleData.id), 
          quantity: 1,
          properties: {
            _item_type: 'main',
            _group_id: 'checkoutGroup',
            _qtyId: qtyID,
            _randomId: Math.random().toString(36).substring(2, 7),
            _discountCode: this.currentBundleData?.discount_code ?? '',
            _discountCodeProduct: this.currentBundleData?.discount_code_product ?? ''
          } 
        });
      }

      // selected products by id -> quantity
      for (const item of this.selectedProducts) {
        items.push({ 
          id: item.id, 
          quantity: item.quantity,
          properties: {
            _item_type: 'subitem',
            _group_id: 'checkoutGroup',
            _qtyId: qtyID,
            _randomId: Math.random().toString(36).substring(2, 7)
          }
        });
      }

      // Include upsell products (each at most once)
      for (const item of this.upsellSelectedProducts) {
        items.push({
          id: Number(item.id),
          quantity: 1,
          properties: {
            _item_type: 'upsell',
            _group_id: 'checkoutGroup',
            _qtyId: qtyID,
            _randomId: Math.random().toString(36).substring(2, 7)
          }
        });
      }
      // Include reward products (each at most once)
      for (const item of this.rewardSelectedProducts) {
        items.push({
          id: Number(item.id),
          quantity: item.quantity,
          properties: {
            _item_type: 'subitem',
            _group_id: 'checkoutGroup',
            _qtyId: qtyID,
            _randomId: Math.random().toString(36).substring(2, 7)
          }
        });
      }
      // Free gift products
      if (this.currentBundleData?.free_gift_ids.length) {
        for (const id of this.currentBundleData.free_gift_ids) {
          items.push({ 
            id, 
            quantity: 1,
            properties: {
              _item_type: 'subitem',
              _group_id: 'checkoutGroup',
              _qtyId: qtyID,
              _randomId: Math.random().toString(36).substring(2, 7)
            }
          });
        }
      }

      if (items.length === 0) {
        buttonEl.disabled = false;
        buttonEl.classList.remove('is-loading');
        return;
      }

      // Add all items to cart then redirect to checkout
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ 
          items ,
          sections: this.cart ? this.cart.getSectionsToRender().map(section => section.section) : [],
          sections_url: window.location.pathname 
        }),
      })
        .then((response) => {
          if (response.ok) {
            response.json().then((data) => {
              console.log("Product added to cart:", data);
              this.cart?.renderContents(data);
            });
          } else {
            response.json().then((error) => {
              console.error("Error adding product to cart:", error);
            });
          }
        })
        .catch((error) => {
          console.error("Fetch error:", error);
        })
        .finally(() => {
          buttonEl.classList.remove('is-loading');
          // window.location.href = '/checkout';
        });
        const discountCode = document.querySelector('.bundle-products__bundle.selected')?.dataset.discountcode;
        if(discountCode){
        const updateRes = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
             discount: discountCode
        })
      });
        if (updateRes.ok) {
          // Success: redirect to checkout
          window.location.href = '/checkout';
        } else {
          // Error updating cart attributes
          console.error("Error updating cart attributes");
          buttonEl.classList.remove('is-loading');
          buttonEl.disabled = false;
        }
      }else{
        window.location.href = '/checkout'
      }
    } catch (err) {
      console.error(err);
      buttonEl.disabled = false;
      buttonEl.classList.remove('is-loading');
    }
  }

  handleNavigationButton(target) {
    const stepIndex = parseFloat(target.dataset.step);
    const showPartyPoppers = target.dataset.showpartypoppers === 'true';
    console.log('showPartyPoppers:', showPartyPoppers);
    this.stepsTab.forEach((tab, index) => {
      const isCompleted = index < stepIndex;
      const isActive = index === stepIndex;
      
      tab.classList.toggle('completed', isCompleted);
      tab.classList.toggle('active', isActive);
    });

    this.steps.forEach(step => step.classList.add('hidden'));
    this.steps[stepIndex].classList.remove('hidden');

    // Start/stop cart reserve timer depending on whether the active step has the timer element
    const timerInStep = this.steps[stepIndex].querySelector('[data-step-cart-reserve-time]');
    if (timerInStep) {
      this.startCartReserveTimer();
    } else {
      this.stopCartReserveTimer();
    }
    if (showPartyPoppers) {
      console.log('Confetti triggered');
    this.showConfetti();
  }
   const scrollContainer = this.closest('.bundle-products-modal') || window;
  if (scrollContainer === window) {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  } else {
    scrollContainer.scrollTo({ top: 0, behavior: 'smooth' });
  }
  }
  handleRewardStep() {
    this.rewardsBlocks.forEach(block => {
      const threshold = parseFloat(block.dataset.rewardsThreshold);
      if (this.totalSpent >= threshold) {
        block.classList.add("active");
      } else {
        block.classList.remove("active");
        const checkedInput = block.querySelector('input:checked');
        if (checkedInput) {
          checkedInput.checked = false;
        }
      }
    });
    setTimeout(() => {
  const data_heading = document.querySelector('.bundle-products__bundle.selected')?.dataset.mystery_color_heading;
  if(data_heading) {
  this.rewardHeading.innerHTML = data_heading ;
  }
}, 1000);
 
  }
  handleBundleSets(currentBundle) {
    this.handleNavigationButton(currentBundle);
    if (currentBundle.classList.contains('selected')) return;
    console.log('Bundle changed');

    this.currentBundleData = this.getCurrentBundle(currentBundle);
    console.log('this.currentBundleData', this.currentBundleData);

    // Update totalSpent based on the selected bundle's price
    if (currentBundle.dataset.price) {
      this.totalSpent = parseInt(currentBundle.dataset.price || 0) / 100;
    } else {
      this.totalSpent = 0;
    }
    this.handleRewardStep();
    console.log('this.totalSpent', this.totalSpent);
    this.bundles.forEach(bundle => bundle.classList.remove('selected'));
    currentBundle.classList.add('selected');

    // Reset selected products when bundle changes
    this.selectedProducts = [];
    
    // Clear any selected states from products
    this.bundleProducts.forEach(product => product.classList.remove('selected'));

    // Reset filters
    this.resetFilters();

    // Update UI with empty selection
    this.updateSelectedProductsUI();
    // Update featured bundle display
    this.updateFeaturedBundleUI();
  }

  handleBundleProducts(bundleProduct) {
    console.log('bundleProduct', bundleProduct);
    
    // Get product data from the clicked element
    const productId = bundleProduct.dataset.id;
    const productImage = bundleProduct.dataset.image;
    const productTitle = bundleProduct.dataset.title;
    
    // Always add on click until bundle limit reached
    if (this.selectedProducts.length < this.currentBundleData.quantity) {
      const productData = { id: productId, quantity: 1, image: productImage, title: productTitle };
      this.selectedProducts.push(productData);
      bundleProduct.classList.add('selected');
    } else {
      console.log('Maximum products reached for this bundle');
      return;
    }
    
    console.log('Selected products:', this.selectedProducts);
    
    // Update the UI to show selected products
    this.updateSelectedProductsUI();
  }

  handleRemoveSelected(buttonEl) {
    const index = parseInt(buttonEl.dataset.removeIndex, 10);
    if (Number.isNaN(index)) return;
    const removed = this.selectedProducts.splice(index, 1)[0];
    if (removed) {
      const stillSelected = this.selectedProducts.some(item => item.id === removed.id);
      if (!stillSelected) {
        const productEl = Array.from(this.bundleProducts).find(el => el.dataset.id === removed.id);
        if (productEl) productEl.classList.remove('selected');
      }
    }
    this.updateSelectedProductsUI();
  }

  handleRemoveAllByProduct(buttonEl) {
    const productId = buttonEl.dataset.id || buttonEl.closest('[data-step-bundle-product]')?.dataset.id;
    if (!productId) return;
    // Remove all instances of this product id from selection
    const hadAny = this.selectedProducts.some(item => item.id === productId);
    if (!hadAny) return;
    this.selectedProducts = this.selectedProducts.filter(item => item.id !== productId);
    // Remove selected class on the grid tile for this product
    const productEl = Array.from(this.bundleProducts).find(el => el.dataset.id === productId);
    if (productEl) productEl.classList.remove('selected');
    // Refresh UI and counts
    this.updateSelectedProductsUI();
  }

  handleFilterTag(filterTag) {
    const tagValue = filterTag.dataset.tag;
    if (!tagValue) return;

    // Toggle active state on the filter tag
    filterTag.classList.toggle('active');
    
    // Get all filter tags to check if any are active
    const allFilterTags = this.querySelectorAll('[data-step-filter-tag]');
    const hasActiveFilters = Array.from(allFilterTags).some(tag => tag.classList.contains('active'));
    
    // Apply filtering
    this.filterProducts(hasActiveFilters ? Array.from(allFilterTags).filter(tag => tag.classList.contains('active')).map(tag => tag.dataset.tag) : []);
  }

  filterProducts(activeTags) {
    this.bundleProducts.forEach(productEl => {
      if (activeTags.length === 0) {
        // No filters active, show all products
        productEl.style.display = '';
        return;
      }

      // Get product tags from data-tags attribute
      const productTags = productEl.dataset.tags;
      if (!productTags) {
        productEl.style.display = 'none';
        return;
      }

      // Check if product has any of the active filter tags
      const productTagArray = productTags.split(',').map(tag => tag.trim().toLowerCase());
      const hasMatchingTag = activeTags.some(activeTag => 
        productTagArray.includes(activeTag.toLowerCase())
      );

      // Show/hide product based on filter match
      productEl.style.display = hasMatchingTag ? '' : 'none';
    });
  }

  resetFilters() {
    // Remove active class from all filter tags
    const allFilterTags = this.querySelectorAll('[data-step-filter-tag]');
    allFilterTags.forEach(tag => tag.classList.remove('active'));
    
    // Show all products
    this.bundleProducts.forEach(productEl => {
      productEl.style.display = '';
    });
  }

  updateSelectedProductsUI() {
    if (!this.bundleSelection) return;
    
    let bundleProductsHTML = '';

    // Show selected products
    this.selectedProducts.forEach((product, index) => {
      bundleProductsHTML += `
        <div class="bundle-products__selected-product">
          <button type="button" class="button button--remove" data-remove-index="${index}" aria-label="Remove">
            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 512 512"><path d="M512 59.076 452.922 0 256 196.922 59.076 0 0 59.076 196.922 256 0 452.922 59.076 512 256 315.076 452.922 512 512 452.922 315.076 256z" fill="currentColor"></path></svg>
          </button>
          <img src="${product.image}" alt="Selected product" loading="lazy">
        </div>
      `;
    });
    
    // Add placeholder products for remaining slots
    const remainingSlots = this.currentBundleData.quantity - this.selectedProducts.length;
    for (let i = 0; i < remainingSlots; i++) {
      bundleProductsHTML += `
        <div class="bundle-products__selected-product">
          <div class="placeholder"></div>
        </div>
      `;
    }

    this.bundleSelection.innerHTML = bundleProductsHTML;
    
    // Enable/disable continue button based on selection
    this.updateContinueButton();
    // Update counts on product tiles
    this.updateProductCounts();
    // Update disabled state on product tiles when selection is complete
    this.updateProductDisabledState();
    // Update featured bundle display
    this.updateFeaturedBundleUI();
  }
  updateRewardProductsUI() {
    const selectionEl = this.querySelector('[data-step-rewards-bundle-selection]');
    if (selectionEl) {
      let selectionHTML = '';
      console.log(this.rewardSelectedProducts);
      this.rewardSelectedProducts.forEach((product, index) => {
        selectionHTML += `
          <div class="featured-bundle__selected-item">
            <div class="media media--1-1">
              <img src="${product.image}" alt="Selected product" loading="lazy">
            </div>
            <p>${product.title}</p>
          </div>
        `;
      });
      selectionEl.innerHTML = selectionHTML;
    }
  }
  // Update featured bundle display elements with current bundle data
  updateFeaturedBundleUI() {
    if (!this.currentBundleData) return;

    // Update bundle media
    const mediaEl = this.querySelector('[data-step-featured-bundle-media]');
    if (mediaEl && this.currentBundleData.image) {
      const imgEl = mediaEl.querySelector('img');
      if (imgEl) {
        imgEl.src = this.currentBundleData.image;
        imgEl.srcset = this.currentBundleData.image;
        imgEl.alt = this.currentBundleData.title || 'Bundle product';
      }
    }

    // Update bundle title
    const titleEl = this.querySelector('[data-step-featured-bundle-title]');
    if (titleEl && this.currentBundleData.title) {
      titleEl.textContent = this.currentBundleData.title;
    }

    // Update bundle quantity
    const quantityEl = this.querySelector('[data-step-featured-bundle-quantity]');
    if (quantityEl && this.currentBundleData.quantity) {
      quantityEl.textContent = `(${this.currentBundleData.quantity} Colours)`;
    }

    // Update bundle selection (selected products)
    const selectionEl = this.querySelector('[data-step-featured-bundle-selection]');
    if (selectionEl) {
      let selectionHTML = '';
      this.selectedProducts.forEach((product, index) => {
        selectionHTML += `
          <div class="featured-bundle__selected-item">
            <div class="media media--1-1">
              <img src="${product.image}" alt="Selected product" loading="lazy">
            </div>
            <p>${product.title}</p>
          </div>
        `;
      });
      selectionEl.innerHTML = selectionHTML;
    }
    
    // Update bundle total price
    const totalEl = this.querySelector('[data-step-featured-bundle-total]');
    if (totalEl && this.currentBundleData.price) {
      const cleanPrice = this.currentBundleData.price.replace(/<[^>]*>/g, '');
      totalEl.textContent = cleanPrice;
    }

    // Update bundle original price (strikethrough)
    const originalPriceEl = this.querySelector('[data-step-featured-bundle-original-price]');
    if (originalPriceEl) {
      if (this.currentBundleData.compare_price && this.currentBundleData.compare_price !== this.currentBundleData.price) {
        const cleanComparePrice = this.currentBundleData.compare_price.replace(/<[^>]*>/g, '');
        originalPriceEl.textContent = cleanComparePrice;
        originalPriceEl.style.display = 'inline';
      } else {
        originalPriceEl.style.display = 'none';
      }
    }
  }

  // Cart reserve timer helpers
  startCartReserveTimer() {
    this.stopCartReserveTimer();
    const timeEl = this.querySelector('[data-step-cart-reserve-time]');
    if (!timeEl) return;
    this.cartReserveEndTime = Date.now() + this.cartReserveDurationMs;
    this.cartReserveTimerInterval = setInterval(() => this.tickCartReserveTimer(), 250);
    this.tickCartReserveTimer();
  }

  stopCartReserveTimer() {
    if (this.cartReserveTimerInterval) {
      clearInterval(this.cartReserveTimerInterval);
      this.cartReserveTimerInterval = null;
    }
  }

  tickCartReserveTimer() {
    const timeEl = this.querySelector('[data-step-cart-reserve-time]');
    if (!timeEl) return;
    let remainingMs = this.cartReserveEndTime - Date.now();
    if (remainingMs <= 0) {
      // restart timer automatically
      this.cartReserveEndTime = Date.now() + this.cartReserveDurationMs;
      remainingMs = this.cartReserveEndTime - Date.now();
    }
    const totalSeconds = Math.floor(remainingMs / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    timeEl.textContent = `${minutes}:${String(seconds).padStart(2, '0')}`;
  }

  updateContinueButton() {
    const continueButton = this.querySelector('[data-step-navigation-bundle-continue]');
    if (continueButton) {
      continueButton.disabled = this.selectedProducts.length !== this.currentBundleData.quantity;
    }
  }

  // Update per-product selection counts in the product grid
  updateProductCounts() {
    // For each product tile, set its count span text to the number of selections
    this.bundleProducts.forEach(productEl => {
      const productId = productEl.dataset.id;
      const count = this.countSelectedById(productId);
      const countEl = productEl.querySelector('[data-step-bundle-product-count]');
      if (countEl) {
        countEl.textContent = String(count);
      }
    });
  }

  // Helper to count how many times a product id is selected
  countSelectedById(productId) {
    let count = 0;
    for (const item of this.selectedProducts) {
      if (item.id === productId) count += 1;
    }
    return count;
  }

  // Add/remove `disabled` class on non-selected products when selection is complete
  updateProductDisabledState() {
    const isComplete = this.isSelectionComplete();
    const selectedIds = new Set(this.selectedProducts.map(p => p.id));
    this.bundleProducts.forEach(productEl => {
      const id = productEl.dataset.id;
      if (isComplete && !selectedIds.has(id)) {
        productEl.classList.add('disabled');
      } else {
        productEl.classList.remove('disabled');
      }
    });
  }

  // Method to get selected products data
  getSelectedProducts() {
    return this.selectedProducts;
  }

  // Method to check if selection is complete
  isSelectionComplete() {
    return this.currentBundleData && this.selectedProducts.length === this.currentBundleData.quantity;
  }

  reset() {
    // Reset selected products
    this.selectedProducts = [];
    
    // Clear selected states from all products
    this.bundleProducts.forEach(product => product.classList.remove('selected'));
    
    // Reset filters
    this.resetFilters();
    
    // Reset to first bundle
    if (this.bundles.length > 0) {
      this.bundles.forEach(bundle => bundle.classList.remove('selected'));
      this.bundles[0].classList.add('selected');
      this.currentBundleData = this.getCurrentBundle(this.bundles[0]);
    }
    
    // Update UI
    this.updateSelectedProductsUI();
    // Update featured bundle display
    this.updateFeaturedBundleUI();
    
    // Reset steps to first step
    this.steps.forEach((step, index) => {
      step.classList.toggle('hidden', index !== 0);
    });
    
    this.stepsTab.forEach((tab, index) => {
      tab.classList.toggle('completed', false);
      tab.classList.toggle('active', index === 0);
    });
  }

  getCurrentBundle(target) {
    this.currentBundleData = JSON.parse(target.querySelector('[type="application/json"]')?.textContent ?? '{}');
    return this.currentBundleData;
  }

  // Toggle upsell selection based on checkbox state
  handleUpsellToggle(checkboxEl) {
    const productEl = checkboxEl.closest('[data-step-upsell-product]');
    if (!productEl) return;
    const id = productEl.dataset.id || checkboxEl.value;
    const image = productEl.dataset.image;
    const title = productEl.querySelector('label p')?.textContent?.trim() || '';

    if (checkboxEl.checked) {
      // Add only if not already present
      const exists = this.upsellSelectedProducts.some(p => String(p.id) === String(id));
      if (!exists) {
        this.upsellSelectedProducts.push({ id, quantity: 1, image, title });
      }
      productEl.classList.add('selected');
    } else {
      // Remove if present
      this.upsellSelectedProducts = this.upsellSelectedProducts.filter(p => String(p.id) !== String(id));
      productEl.classList.remove('selected');
    }

    this.updateUpsellSelectedProductsUI();
  }

  // Remove upsell via selected list button
  handleUpsellRemove(buttonEl) {
    const id = buttonEl.dataset.upsellRemoveId;
    if (!id) return;
    // Uncheck the corresponding checkbox
    const checkbox = this.querySelector(`input[type="checkbox"][name^="bundle-upsell-"][value="${id}"]`);
    if (checkbox) {
      checkbox.checked = false;
      this.handleUpsellToggle(checkbox);
    } else {
      // Fallback: just remove from array/UI
      this.upsellSelectedProducts = this.upsellSelectedProducts.filter(p => String(p.id) !== String(id));
      this.updateUpsellSelectedProductsUI();
      // Also clear selected class on tile
      const productEl = Array.from(this.upsellProducts).find(el => String(el.dataset.id) === String(id));
      if (productEl) productEl.classList.remove('selected');
    }
  }

  // Render selected upsell products list
  updateUpsellSelectedProductsUI() {
    if (!this.upsellSelection) return;
    // Ensure there is exactly one placeholder at the end
    let placeholderWrapper = Array.from(this.upsellSelection.children)
      .find(el => el.querySelector && el.querySelector('.placeholder'));

    if (!placeholderWrapper) {
      // Append a placeholder if missing
      const placeholderHTML = `
        <div class="bundle-products__selected-product">
          <div class="placeholder"></div>
        </div>
      `;
      this.upsellSelection.insertAdjacentHTML('beforeend', placeholderHTML);
      placeholderWrapper = Array.from(this.upsellSelection.children)
        .find(el => el.querySelector && el.querySelector('.placeholder'));
    }

    // Remove previously rendered selected upsell entries (keep placeholder)
    Array.from(this.upsellSelection.children).forEach(child => {
      if (!(child.querySelector && child.querySelector('.placeholder'))) {
        child.remove();
      }
    });

    // Insert current selections before the placeholder
    let html = '';
    this.upsellSelectedProducts.forEach((product) => {
      html += `
        <div class="bundle-products__selected-product">
          <button type="button" class="button button--remove" data-upsell-remove-id="${product.id}" aria-label="Remove">
            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 512 512"><path d="M512 59.076 452.922 0 256 196.922 59.076 0 0 59.076 196.922 256 0 452.922 59.076 512 256 315.076 452.922 512 512 452.922 315.076 256z" fill="currentColor"></path></svg>
          </button>
          <img src="${product.image}" alt="${product.title || 'Selected upsell'}" loading="lazy">
        </div>
      `;
    });

    if (html) {
      placeholderWrapper.insertAdjacentHTML('beforebegin', html);
    }
  }

  // Clear upsell selections and UI (used by Skip button)
  handleUpsellSkip() {
    // Clear array
    this.upsellSelectedProducts = [];
    // Uncheck all upsell checkboxes
    const upsellCheckboxes = this.querySelectorAll('input[type="checkbox"][name^="bundle-upsell-"]');
    upsellCheckboxes.forEach(cb => { cb.checked = false; });
    // Remove selected class from upsell tiles
    this.upsellProducts.forEach(el => el.classList.remove('selected'));
    // Re-render with placeholder kept at end
    this.updateUpsellSelectedProductsUI();
  }

showConfetti() {
  // Create a canvas for confetti
  const canvas = document.createElement('canvas');
  canvas.style.position = 'fixed';
  canvas.style.left = 0;
  canvas.style.top = 0;
  canvas.style.width = '100vw';
  canvas.style.height = '100vh';
  canvas.style.pointerEvents = 'none';
  canvas.style.zIndex = 9999;
  canvas.width = window.innerWidth;
  canvas.height = window.innerHeight;
  document.body.appendChild(canvas);

  const ctx = canvas.getContext('2d');
  const confettiCount = 120;
  const confetti = [];

  for (let i = 0; i < confettiCount; i++) {
    const x = Math.random() * canvas.width;
    const y = 0; // Start at the top
    const r = Math.random() * 6 + 4;
    const color = `hsl(${Math.random() * 360}, 70%, 60%)`;
    const tilt = Math.random() * 10 - 10;
    const vx = Math.random() * 2 - 1; // Gentle horizontal drift
    const vy = Math.random() * 2 + 2; // Downward speed
    const gravity = 0.03 + Math.random() * 0.02;
    confetti.push({ x, y, r, color, tilt, vx, vy, gravity, alpha: 1 });
  }

  function draw() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    for (let i = 0; i < confetti.length; i++) {
      let c = confetti[i];
      if (c.alpha <= 0) continue;
      ctx.save();
      ctx.globalAlpha = c.alpha;
      ctx.beginPath();
      ctx.lineWidth = c.r;
      ctx.strokeStyle = c.color;
      ctx.moveTo(c.x + c.tilt + c.r / 3, c.y);
      ctx.lineTo(c.x + c.tilt, c.y + c.tilt + c.r / 5);
      ctx.stroke();
      ctx.restore();
    }
  }

  function update() {
    for (let i = 0; i < confetti.length; i++) {
      let c = confetti[i];
      c.x += c.vx;
      c.y += c.vy;
      c.vy += c.gravity;
      c.tilt = Math.sin(c.x * 0.05) * 15;
      if (c.y > canvas.height) c.alpha = 0; // Fade out when out of view
      c.alpha -= 0.004; // Slow fade
    }
  }

  let frame = 0;
  function animate() {
    update();
    draw();
    frame++;
    if (frame < 180) {
      requestAnimationFrame(animate);
    } else {
      document.body.removeChild(canvas);
    }
  }
  animate();
}
}

customElements.define('bundle-products', BundleProducts);

class BundleProductsModalOpener extends HTMLButtonElement {
  constructor() {
    super();
  }

  connectedCallback() {
    console.log('BundleProductsModalOpener init');

    this.addEventListener('click', (event) => {
      console.log('is button element');
      const modal = document.getElementById(`Modal-${this.dataset.modal}`);
      modal?.open();
    });
  }
}

if (!customElements.get('bundle-products-modal-opener')) {
  customElements.define('bundle-products-modal-opener', BundleProductsModalOpener, { extends: 'button' });
}